const defaultIdleTimeoutMinutes = 15;
const activityWriteIntervalMs = 5000;
const millisecondsPerMinute = 60000;

let lastActivityWrite = 0;

export const idleTimeoutOptions = [
    { minutes: 2, label: '2 minutes' },
    { minutes: 5, label: '5 minutes' },
    { minutes: 15, label: '15 minutes' },
    { minutes: 60, label: '1 hour' },
    { minutes: 240, label: '4 hours' },
    { minutes: 720, label: '12 hours' },
];

export class IdleSession {
    public static getIdleTimeoutMinutes(): number {
        try {
            const summary = JSON.parse(
                localStorage.getItem('loggedInUserSummary')
            );
            return summary?.idleTimeoutMinutes || defaultIdleTimeoutMinutes;
        } catch {
            return defaultIdleTimeoutMinutes;
        }
    }

    public static recordActivity(force = false) {
        if (!localStorage.getItem('token')) return;
        const now = Date.now();
        if (!force && now - lastActivityWrite < activityWriteIntervalMs) return;
        if (!force && !IdleSession.isDeadlineAhead()) return;
        lastActivityWrite = now;
        const deadline = new Date(
            now + IdleSession.getIdleTimeoutMinutes() * millisecondsPerMinute
        );
        localStorage.setItem('expirationDate', deadline.toString());
    }

    public static isDeadlineAhead(): boolean {
        const deadline = new Date(localStorage.getItem('expirationDate'));
        return !isNaN(deadline.getTime()) && deadline.getTime() > Date.now();
    }

    public static getPopupLeadMinutes(adminLeadMinutes: number): number {
        return Math.min(
            adminLeadMinutes,
            IdleSession.getIdleTimeoutMinutes() / 2
        );
    }
}
